<template>
  <div>
    <v-dialog
            v-model="dialogCompose"
            width="500">
      <v-card class="card-custom">
        <v-card-title>
          <v-row>
            <v-col cols="10" class="text-left text-h5">
              Copy Program
            </v-col>
            <v-col cols="2" class="text-right action">
              <span class="font-weight-bold text-h6" @click="closeModal">
                 X
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pa-5 text-center font-weight-bold">
          You wish to create a new program based on
          <div class="primary-color">
            {{this.currentProgram.name}}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn class="copy-btn" @click="copyProgram(currentProgram.id)">
              Copy
            </v-btn>
          </v-col>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
            v-model="dialogDelete"
            width="500">
      <v-card class="card-custom" style="background-color: #f5f5f5 !important;">
        <v-card-title>
          <v-row>
            <v-col cols="10" class="text-left text-h5 font-weight-bold" style="color: #3A3852">
              Delete Program
            </v-col>
            <v-col cols="2" class="text-right action">
              <span class="font-weight-bold text-h6" @click="closeModal">
                 X
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pa-5 text-center font-weight-bold">
          Are you sure you want to delete
          <div class="primary-color">
            {{this.currentProgram.name}} ?
          </div>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn class="copy-btn" @click="deleteProgram(currentProgram.id)">
              Delete
            </v-btn>
          </v-col>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
            v-model="dialogError"
            width="500">
      <v-card class="card-custom" style="background-color: #f5f5f5 !important; color: #3A3852">
        <v-card-title>
          <v-row>
            <v-col cols="10" class="text-left text-h5 font-weight-bold" >
              Program in use
            </v-col>
            <v-col cols="2" class="text-right action">
              <span class="font-weight-bold text-h6" @click="closeModal">
                 X
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pa-5 text-center font-weight-bold">
          You can not delete this program as it is used by at least one campaign/offer.
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="d-md-flex align-center justify-space-between fill-width">
      <h1 class="mb-0 mr-3">
        Programs
        <v-btn
            v-if="user[0].can('create_programs')"
            color="primary"
            x-small
            @click="createProgram"
            style="min-width: 0; min-height: 30px"
        >
          <span style="font-size: 24px">
            <i class="fas fa-plus"></i>
          </span>

        </v-btn>
      </h1>
      <div class="d-md-flex align-center justify-space-between fill-width">
      </div>
    </div>
    <div>
      <v-data-table
        :headers="table.headers"
        :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
        :items="programs"
        :disable-sort="true"
        :loading="table.loading"
        :footer-props="{itemsPerPageOptions: table.pageOptions}"
        :items-per-page="table.perPage"
        :expanded.sync="table.expanded"
        :single-expand="false"
        item-key="id"
        show-expand
        loading-text="Loading... Please wait"
        fixed-header
        :class="`elevation-1 fixed-height co-data-table items-size-${table.heightCounter}`"
        item-class="td_title"
        color="#7F98A5"
        @pagination="updateTablePagination"
      >
        <template v-slot:top>
          <DataTableTopBar @search="search" placeholder="Search Program or Geo"/>
        </template>
        <template #item.code="{ item }">
          -
        </template>
        <template #item.name="{ item }">
          {{item.name}}
          <span v-if="item.isRestricted === 1" class="primary-color">
            <i class="fad fa-shield"></i>
          </span>
        </template>
        <template #item.geo="{ item }" class="text-left">
          {{ item.geos.length }} {{item.geos.length === 1 ? 'geo' : 'geos'}}
        </template>
        <template #item.margin="{ item }">
          {{(item.price-item.payout).toFixed(2)}}
          ({{ item.payout === 0 ? 0 : (( 1-(item.payout/item.price))*100).toFixed(2) }}%)
        </template>
        <template #item.actions="{ item }">
          <span class="mr-3 primary-color action" @click="editProgram(item.id)">
            <i class="fas fa-pen"></i>
          </span>
          <span class="mr-3 primary-color action" @click="openModal(item.id, 'copy')">
            <i class="fas fa-copy"></i>
          </span>
          <span class="primary-color action">
            <span class="mr-3 primary-color action" @click="download(item.id)">
              <i class="fas fa-download"></i>
            </span>
          </span>
          <span class="primary-color action">
            <span class="mr-3 primary-color action" @click="openHistory(item.id)">
              <i class="fas fa-history"></i>
            </span>
          </span>
          <span class="primary-color action">
            <span class="mr-3 primary-color action" @click="openModal(item.id, 'delete')">
              <i class="fas fa-trash"></i>
            </span>
          </span>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pa-0 ma-0">
            <v-simple-table class="ma-0 pa-0 scrollable-expand">
              <template v-slot:default>
                <tbody>
                <tr v-for="(value, index) in item.geos"
                    :key="index"
                >
                  <td class="px-4" style="width: 52px"></td>
                  <td class="px-4" style="width: 72px"></td>
                  <td class="px-4" style="width: 144px"></td>
                  <td class="px-4" style="width: 106px" v-if="!canSeeProfit"></td>
                  <td class="px-4" style="width: 60px" v-if="canSeeProfitButNotActions"></td>
                  <td style="width: 90px" class="text-right mr-0">{{value.code}}</td>
                  <td style="width: 75px;" class="text-right ml-0 pl-0">{{value.name}}</td>
                  <td class="px-4" style="width: 120px"></td>
                  <td class="px-4" style="width: 112px"></td>
                  <td style="width: 128px; padding-right: 45px" class="text-right">
                    <div v-if="!canSeeProfit" style="width:50px;height: auto;"/>
                    {{value.payout}}
                  </td>
                  <td v-if="canSeeProfit" style="width: 106px">{{value.price}}</td>
                  <td v-if="canSeeProfit" class="px-4" style="width: 90px">
                    {{(value.price-value.payout).toFixed(2)}}
                    ({{ value.payout === 0 ? '0' : (( 1-(value.payout/value.price))*100).toFixed(2) }}%)
                  </td>
                  <td class="px-4" style="width: 274px"></td>
                  <td class="px-4" style="width: 90px" v-if="!canSeeProfit && canSeeProfitButNotActions"></td>
                  <td class="px-4" style="width: 95px" v-if="!canSeeProfitButNotActions && canSeeProfit"></td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
        </template>
        <template v-for="item of table.headers" :slot="`header.${[item.value]}`" slot-scope="{header}">
          <data-filter
            :type="table.filters[header.value]['isRange'] ? 'range' : 'items'"
            :min="table.filters[header.value].min"
            :max="table.filters[header.value].max"
            v-if="table.filters.hasOwnProperty(header.value)"
            :items="table.filters[header.value].data"
            :entity="header.value"
            :values="table.filters[header.value].selected"
            @apply="submitFilter"
            @search="updateDataInFilters"
          />
          <a v-if="header.sortable" @click="sortColumn(header.value)">
            <span class="header_title primary-color">{{header.text}}</span>
            <v-icon
                    size="16"
                    color="#7F98A5"
            >
              mdi-arrow-{{header.value === table.orderBy ? table.sortColumnsAsc ? 'up' : 'down' : 'up-down'}}
            </v-icon>
          </a>
          <span v-else class="header_title primary-color">{{header.text}}</span>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>

  import {mapGetters, mapState} from 'vuex';

  import store from "@/store";
  import DataTableTopBar from '@/components/common/DataTableTopBar';
  import programs from "@/api/programs";
  import download from "@/helpers/download";

  export default {
    name: 'Programs',
    components: {
      DataTableTopBar
    },
    computed: {
      ...mapState('user', ['user']),
      ...mapGetters('programs', ['programs', 'getProgramsCanNotBeDeleted']),
      ...mapGetters('programs', ['filters']),

    },
    async created() {
      if (!this.user[0].can('access_programs')){
        await this.$router.push('/403');
      }
    },
    async mounted() {
      this.canSeeProfit = this.user[0].can('see_profit');
      this.canSeeProfitButNotActions = this.canSeeProfit && !this.user[0].can('create_programs');
      console.log(this.user[0].can('create_programs'), this.user[0].can('see_profit'))
      console.log(this.canSeeProfit, this.canSeeProfitButNotActions)
      this.table.headers = this.table.headers.filter(
        h => !(['price', 'margin'].includes(h.value) && !this.canSeeProfit)
      );
      this.table.headers = this.table.headers.filter(
              h => !(['actions'].includes(h.value) && !this.user[0].can('create_programs'))
      );
      await this.getTableData();
      await this.getFiltersData();
    },
    methods: {
      createProgram() {
        this.$router.push(`/advertisers/programs/create`);
      },
      editProgram(id) {
        const program = this.programs.find(p => p.id === Number(id));
        if (program) {
          localStorage.setItem("program", JSON.stringify(program));
          this.$router.push(`/advertisers/programs/edit/${id}`);
        }
      },
      download(id) {
        const program = this.programs.find(p => p.id === Number(id));
        const geos = program.geos.map(geo => ({
          geo: geo.code,
          payout: parseFloat(geo.payout.toFixed(2))
        }));
        geos.unshift({geo: 'WW', payout: parseFloat(program.payout.toFixed(2))});
        download(geos);
      },
      openHistory(id) {
        const program = this.programs.find(p => p.id === Number(id));
        if (program) {
          localStorage.setItem("program", JSON.stringify(program));
          localStorage.setItem("activeTab", 'history');
          this.$router.push(`/advertisers/programs/edit/${id}`);
        }
      },
      openModal(id, action) {
        this.currentProgram = this.programs.find(p => p.id === Number(id));
        if (action === 'delete') {
          if (this.getProgramsCanNotBeDeleted.includes(id)) {
            this.dialogError = true;
            return;
          }
          this.dialogDelete = true;
        } else if(action === 'copy')
        this.dialogCompose = true;
      },
      closeModal() {
        this.dialogCompose = false;
        this.dialogDelete = false;
        this.dialogError = false
      },
      copyProgram(id) {
        const program = this.programs.find(p => p.id === Number(id));
        if (program) {
          localStorage.setItem("program", JSON.stringify(program));
          this.$router.push(`/advertisers/programs/create/${program.id}`);
          this.dialogCompose = false;
        }
      },
      async deleteProgram(id) {
        this.closeModal();
        const deleteResult = await programs.deleteProgram(id, this.user[0].email);

        if (!deleteResult) {
          this.dialogError = true;
          return;
        }
        await this.getTableData();
      },
      async sortColumn(column) {
        this.table.sortColumnsAsc = (this.table.orderBy === column) ? !this.table.sortColumnsAsc : true;
        this.table.orderBy = column;
        await this.getTableData();
      },
      addParamsToLocation(params) {
        const query = JSON.stringify(params) === '{}' ? this.$route.path :
                this.$route.path + '?' + Object.keys(params).map(
                key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
                ).join('&')
        history.pushState({},null, query);
      },
      updateTablePagination(params){
        if (
                (this.table.currentPage === params.page &&
                        this.table.perPage === params.itemsPerPage) ||
                this.table.pageChangedByMe
        ) {
          this.table.pageChangedByMe = false;
          return
        }
        this.table.currentPage = params.page
        this.table.perPage = params.itemsPerPage
        /* if(this.$route.query.filters) {
          this.updateFiltersFromQuery();
        }
        this.getTableData(); */
      },
      async getFiltersData() {
        Object.keys(this.table.filters).forEach(name => {
          if (this.filters[name]) {
            this.table.filters[name]['data'] = this.filters[name];
            if (this.table.filters[name]['isRange']) {
              this.table.filters[name].min = Number(this.filters[name].find(f => f.key === 'min')['value']);
              this.table.filters[name].max = Number(this.filters[name].find(f => f.key === 'max')['value']);
            }
          }

          this.table.filters[name].data = this.filters[name]
        })

      },
      async submitFilter(data, entity) {
        this.table.currentPage = 1;
        if(data && entity) {
          this.table.filters[entity].selected = data;
        }
        return await this.getTableData()
      },
      async getTableData() {
        this.table.loading = true;
        this.activateFilters();
        const filters = await this.getFilters();

        await store.dispatch('programs/getPrograms', {
          limit: this.table.perPage,
          page: this.table.currentPage,
          orderBy: this.table.orderBy,
          orderDirectionAsc: this.table.sortColumnsAsc,
          filters: filters || null
        });

        await store.dispatch('programs/getProgramsCanNotBeDeleted');

        this.table.loading = false

      },
      activateFilters() {
        const filtersForQuery = {};
        for (const name in this.table.filters) {
          if(this.table.filters[name].selected.length > 0) {
            filtersForQuery[name] = this.table.filters[name].selected;
          }
        }
        this.addParamsToLocation(
                JSON.stringify(filtersForQuery) !== '{}' ? {filters: JSON.stringify(filtersForQuery)} : {}
        );
      },
      async getFilters() {
        const filters = {};
        filters['search'] = (this.table.searchInPrograms.length > 0) ? this.table.searchInPrograms : '';
        for(const name in this.table.filters) {
          filters[name] = (this.table.filters[name].selected.length > 0)
                  ? `${this.table.filters[name].selected.join(',')}`
                  : null;
        }
        return filters;
      },
      search(value) {
        this.table.searchInPrograms = value;
        this.submitFilter();
      },
      async updateDataInFilters(data, modalName) {

      },
    },
    data() {
      return {
        dialogCompose: false,
        dialogDelete: false,
        dialogError: false,
        currentProgram: {},
        table: {
          searchInPrograms: '',
          heightCounter: 45,
          currentPage: 1,
          perPage: 25,
          orderBy: '',
          sortColumnsAsc: true,
          pageOptions: [10, 25, 50, 100],
          loading: false,
          expanded: [],
          headers: [
            { text: 'ID', value: 'id', class: 'test', align: 'center', sortable: true},
            { text: 'Program', value: 'name', align: 'center', sortable: true },
            { text: 'Code', value: 'code', align: 'center' },
            { text: 'Geo', value: 'geo', align: 'left' }, // number of geos
            { text: 'Advertiser', value: 'advertiser', align: 'center', sortable: true },
            { text: 'Currency', value: 'currency', align: 'center', sortable: true },
            { text: 'Payout', value: 'payout', align: 'center', sortable: true},
            { text: 'Price', value: 'price', align: 'center', sortable: true },
            { text: 'Margin', value: 'margin', align: 'center', sortable: false },
            { text: 'Last Updated By', value: 'lastUpdatedBy', align: 'center', sortable: true },
            { text: 'Actions', value: 'actions', align: 'center', sortable: false },
          ],
          filters: {
            name: {selected: [], data: [], min: 0, max: 1, isRange: false},
            advertiser: {selected: [], data: [], min: 0, max: 1, isRange: false},
            currency: {selected: [], data: [], min: 0, max: 1,isRange: false},
            payout: {selected: [], data: [], min: 0, max: 1, isRange: true},
            price: {selected: [], data: [], min: 0, max: 1, isRange: true},
            lastUpdatedBy: {selected: [], data: [], min: 0, max: 1, isRange: false},
          },
          canSeeProfit: false,
          canSeeProfitButNotActions: false
        },
      }
    }
  }
</script>

<style lang="sass">
  .action :hover
    cursor: pointer
  .copy-btn
    background: #acc3cf !important
    color: white !important
    width: 130px
    text-transform: unset !important
  .v-data-table-header th a span

  .card-custom
    background: #f5f5f5 !important
  .v-tooltip__content
    opacity: 1 !important
    background-color: #3A3852 !important
    .v-text-field-modifier
      width: 50px
    .scrollable-expand
      width: inherit !important
      padding: 8px
      box-sizing: border-box
      overflow-y: auto
      .v-data-table__wrapper
        height: auto !important
        .spacer
          width: 0
          padding-right: 40px
</style>

// eslint-disable-next-line no-undef